<!--
 * @Overview:   RiskQuestionnaire
 * @Author:     Zi_Jun
 * @Email:      zijun2030@163.com
 * @Date:       2020/7/13 16:42
 * @Mark:       1、问卷问题循环遍历处理
 -->

<template>
  <div class="risk-questionnaire" ref="questionRef">
    <Progress progress="46"></Progress>
    <!-- Title: Questions title -->
    <div class="title ">
      <p class="primary-text">{{ titleText }}</p>
      <!-- <p class="mark-text">{{ titleMark }}</p> -->
    </div>
    <div class="questions" ref="questionsDom">
      <div
        class="questions-item"
        :class="`question${index + 1}`"
        v-for="(item, index) in questions"
        :key="item.title"
      >
        <div class="item-title">
          <!-- <span v-if="item.isMust" class="my-must">*</span> -->
          <p>
            <span class="normal-text">{{ item.id }}、</span>
            <span v-if="item.preTitle" class="pre-text">{{
              item.preTitle
            }}</span>
            <span class="normal-text">{{ item.title }}</span>
            <span v-if="item.posTitle" class="pre-text">{{ item.posTitle }}</span>
          </p>
        </div>

        <van-checkbox-group v-model="item.result" v-if="item.isCheck">
          <div class="radio-dom" v-for="child in item.choices" :key="child.text">
            <van-checkbox
              :name="child.name"
              :ref="item.ref"
            >
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ child.text }}
            </van-checkbox>
<!--            <div class="radio-text">{{ child.text }}</div>-->

          </div>
        </van-checkbox-group>

        <van-radio-group v-model="item.result" v-else>
          <div class="radio-dom" v-for="child in item.choices" :key="child.text">
            <van-radio :disabled="getDisRadio(index)" :name="child.name">
              <template #icon="props">
                <img class="img-icon" :src="getIcon(getDisRadio(index),props.checked)" />
              </template>
              {{ child.text }}
            </van-radio>
<!--            <div class="radio-text1">-->
<!--              -->
<!--            </div>-->
          </div>
        </van-radio-group>
      </div>
    </div>
    <nav-buttons
      :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"
      @on-next="handleButtonClick" :disabled="getRiskDis"></nav-buttons>
  </div>
</template>

<script>
import navButtons from "../components/navButtons.vue";
import { Cell, CellGroup, Checkbox, CheckboxGroup, Radio, RadioGroup, Toast } from "vant";
import Progress from "../components/Progress.vue";
import RadioNone from '@/assets/images/open-account/radio.png'
import RadioCheck from '@/assets/images/open-account/radio_check.png'
import CheckNone from '@/assets/images/open-account/check_none.png'
import Checkd from '@/assets/images/open-account/check.png'

import RadioNoneDis from '@/assets/images/open-account/radio_none_dis.png'
import RadioDis from '@/assets/images/open-account/radio_dis.png'

export default {
  components: {
    VanRadioGroup: RadioGroup,
    VanRadio: Radio,
    VanCheckboxGroup: CheckboxGroup,
    VanCheckbox: Checkbox,
    VanCellGroup: CellGroup,
    VanCell: Cell,
    navButtons,
    Progress
  },
  data() {
    return {
      RadioNone,
      RadioCheck,
      CheckNone,
      Checkd,
      RadioNoneDis,
      RadioDis,
      questions: [],
      curDay: new Date().getFullYear(),
      birth: "",
      process_id: "",
      isChange: ""
    };
  },
  computed: {
    titleText() {
      return this.$t("assessment.question.titleText");
    },
    titleMark() {
      return this.$t("assessment.question.titleMark");
    },
    // 判断是否符合年龄
    getAgeRange() {
      const birthYear = this.birth ? this.birth.split('-') : 0;
      const isBirth = this.curDay - Number(birthYear[0]);

      let num = 'b';
      if (isBirth >= 18 && isBirth <= 35) {
        num = "a";
      } else if (isBirth >= 36 && isBirth < 44) {
        num = "b";
      } else if (isBirth >= 44 && isBirth < 55) {
        num = "c";
      } else if (isBirth >= 55 && isBirth <= 65) {
        num = "d";
      } else if (isBirth > 65) {
        num = "e";
      }

      return num;
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getRiskDis(){
      let btnDis = false
      if(!this.questions[2].result || this.questions[2].result.length == 0){
        btnDis = true
      }
      return btnDis
    }
  },
  created() {
    this.isChange = this.$route.query.change;
    this.init();
    this.handDetail();
  },
  methods: {
    init() {
      this.questions = this.$t("riskQuestionnaire.question.question")
      this.$nextTick(() =>{
        const box = document.getElementById("app");
        if(box.scrollTo){
          box.scrollTo(0,0)
        }else{
          box.scrollTop = 0
        }
      })
    },
    handDetail() {
      const params = {
        step_code:'1,3-2,6,7,8-1'
      }
      this.$apis.accountSituationV2(params).then(res => {
        if (res.process_info) {
          this.process_id = res?.process_info["1"]?.process_id; // 获取开户类型
          const { config_data } = res?.process_info?.["8-1"] || {}; // 获取问卷回填数据
          if(config_data && config_data != '{}'){
            const questionsForm = JSON.parse(config_data)
            questionsForm.content.forEach((item,index) =>{
              this.questions[index].result = item.result
            })
          }
          const birthForm = res?.process_info?.["3-2"]?.config_data || {}; // 获取身份出生日期
          const surveyForm = res?.process_info?.["7"]?.config_data || {}; // 获取适当性调查相关信息
          const { investmentExp } = JSON.parse(surveyForm)?.examine_list;

          this.birth = JSON.parse(birthForm).birth;

          const personForm = res?.process_info["6"]?.config_data || {}; // 获取个人信息相关信息
          this.$nextTick(() =>{
            // 默认学历
            this.questions[1].result = String(this.getPersonCheck(JSON.parse(personForm).education));
            // 默认年龄
            this.questions[0].result = this.getAgeRange;
            // 默认第四题
            this.questions[3].result = String(this.getQ(investmentExp[1]?.value));
            // 默认第五题
            this.questions[4].result = String(this.getQ(investmentExp[5]?.value));
          })


        }
      })
    },

    // 判断适当性调查答案
    getQ(result){
      let num = 'c'
      const key = {
        1:'a',
        2:'b',
        3:'c'
      }
      if(Number(result) > 3){
        num = 'd'
      } else {
        num = key[result]
      }
      return num
    },

    // 获取图标
    getIcon(disable,check){
      if(disable){
        return check ? this.RadioDis : this.RadioNoneDis
      }else{
        return check ? this.RadioCheck : this.RadioNone
      }
    },


    // onClickRadio(child, index) {
    //   const { name } = child;
    //   switch (index) {
    //     case 0:
    //       if (this.getAgeRange != name) {
    //         Dialog.alert({
    //           message: `${this.$t("assessment.question.derivative_clew")}`,
    //           className: document.getElementsByClassName("black-theme")[0] ? "black-theme-dialog" : ""
    //         }).then(() => {
    //           this.questions[index].result = "";
    //           this.nextDis = true;
    //         });
    //       } else {
    //         this.nextDis = false;
    //       }
    //       break;
    //     case 3:
    //       if (this.getQ4 != name) {
    //         Dialog.alert({
    //           message: `${this.$t('assessment.question.derivative_clew_two')}`,
    //           className: document.getElementsByClassName("black-theme")[0] ? "black-theme-dialog" : ""
    //         }).then(() => {
    //           this.questions[index].result = "";
    //           this.nextDis = true;
    //         });
    //       } else {
    //         this.nextDis = false;
    //       }
    //       break;
    //     case 4:
    //       if (this.getQ5 != name) {
    //         Dialog.alert({
    //           message: `${this.$t('assessment.question.derivative_clew_two')}`,
    //           className: document.getElementsByClassName("black-theme")[0] ? "black-theme-dialog" : ""
    //         }).then(() => {
    //           this.questions[index].result = "";
    //           this.nextDis = true;
    //         });
    //       } else {
    //         this.nextDis = false;
    //       }
    //       break;
    //   }
    // },

    // 判断禁用
    getDisRadio(index){
      let dis = false
      let arrayIndex = [0,3,4] // 默认1,4,5题不允许修改
      const change = this.$route.query.change
      if(arrayIndex.includes(index) && (!change || change != 1)){
        dis = true
      }
      if(change && change == 1){  // 修改时4,5题不允许修改
        arrayIndex = [3,4]
        if(arrayIndex.includes(index)){
          dis = true
        }
      }
      return dis
    },

    // 默认学历
    getPersonCheck(item) {
      const key = {
        1: "a",
        2: "b",
        3: "d",
        4: "d"
      };
      return key[item];
    },

    handleButtonClick() {
      if(this.getRiskDis){
        return
      }
      const params = {
        process_id: this.process_id,
        step_code: "8-1",
        step_order: 8,
        config_data: {
          content: this.questions
        }
      };
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .supplementSaveApi(params)
        .then((res) => {
          if (res) {
            if(this.isChange == 1){
              this.$router.go(-1).finally(() => {
                toastLoading.clear();
              });
            }
            else {
              this.$router.push({
                path: "/open-account/assessmentResult",
                query:{
                  ...this.$route.query
                }
              }).finally(() => {
                toastLoading.clear();
              });
            }
          }
        });
    }
  }
}

</script>

<style scoped lang="less">
.risk-questionnaire {
  padding-top: 62px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 88px;
    line-height: 88px;
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
    .primary-text {
      font-size: 36px;
      line-height: 36px;
      color: #17161C;
      font-weight: 500;
    }
    .mark-text {
      font-size: 24px;
      line-height: 36px;
      color: #F24E1E;
    }
  }
  .questions {
    background: #fff;
    padding-bottom: 200px;
  }
  .questions-item {
    margin-left: 32px;
    margin-right: 32px;
    margin-top: 44px;
    .item-title {
      display: flex;
      font-size: 32px;
      line-height: 44px;
      color: #17161C;
      font-weight: 500;
      .my-must {
        color: #FD2626;
      }
      .pre-text {
        color: #888;
      }
    }
  }
  .van-cell {
    height: auto !important;
  }
  .cell-item {
    display: flex;
    justify-content: space-between;
    padding: 14px 18px 12px 16px !important;
    &:not(:first-of-type) {
      margin-top: 5px;
    }
  }

  .cell-item .van-cell__title {
    max-width: 596px;
    padding: 0;
    font-size: 24px;
    line-height: 34px;
    color: #444;
  }
  /deep/ .van-checkbox {
    // align-items: center !important;
    align-items: flex-start;
    margin-bottom: 0 !important;
  }
  /deep/ .van-checkbox__icon {
    transform: translateY(6px);
    height: auto;
  }
  /deep/ .van-checkbox .van-icon {
    font-size: 24px !important;
  }
  /deep/ .van-radio__icon {
    display: flex;
    align-items: center;
  }
  /deep/ .van-radio .van-icon {
    font-size: 24px;
  }
  /deep/ .van-radio {
    align-items: flex-start;
    .van-radio__icon {
      // transform: translateY(2px);
    }
  }
  .button {
    padding: 40px 48px 208px;
  }
}
@black: #1B1C24;
.black-theme {
  background-color: @black;
  min-height: 100%;
  color: #fff;
  .questions{
    background-color: @black;
    color: #fff;
  }
  .risk-questionnaire .title .primary-text{
    color: #fff;
  }
  .risk-questionnaire .questions-item .item-title{
    color: #fff;
  }
  .van-cell-group{
    background-color: @black;
    color: #fff;
  }
  /deep/ .van-field__control{
    color: #fff;
  }
  .risk-questionnaire .cell-item .van-cell__title{
    color: #fff;
  }
  .risk-questionnaire .questions-item .item-title .pre-text{
    color: #fff;
  }
  /deep/.van-field__label{
    color: #fff;
  }
  .footer-panel{
    background-color: @black;
    color: #fff;
  }
  /deep/ .van-radio__label {
    color: white !important;
  }
  /deep/ .van-radio__icon--checked .van-icon{
    background-color: #377CFB !important;
    border-color: #377CFB !important;
  }

  /deep/ .van-checkbox__icon .van-checkbox__icon--checked .van-icon .van-icon-success{
    background-color: #377CFB !important;
    border-color: #377CFB !important;
  }

  /deep/ .van-button--normal{
    background-color: #377CFB !important;
    border-color: #377CFB !important;
  }
  .risk-questionnaire {
    .title {
      border-color: #323442;
    }
    .questions-item {
      /deep/ .van-radio__label {
        color: white;
      }
    }
  }
}
.black-theme-dialog{
  .van-button--default{
    background-color: #0a0b0f;
    color: #fff;
  }
}
/deep/ .van-checkbox__icon .van-checkbox__icon--checked .van-icon .van-icon-success{
  background-color:#1C0955;
  border-color: #1C0955;
}
/deep/ .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border: 0px;
}
/deep/ .van-radio__label--disabled {
  color: #323233;
}
// icon
.img-icon{
  width: 28px;
  height: 28px;
}

.radio-dom{
  display: flex;
  margin-top: 20px;
  .radio-text{
    font-size: 28px;
    width: 100%;
    margin-left: 20px;
  }
  .radio-text1{
    font-size: 28px;
    margin-left: 24px;
    width: 95%;
  }
}
.van-hairline--bottom::after{
  top: 120%;
}
@supports (-webkit-touch-callout: none) {
  .img-icon {
    transform: translateY(-2px);
  }
}

</style>
